export {Artwork as Page};

import {Helmet} from "react-helmet-async";
import {useEffect, useState} from "preact/hooks";
import {AccountSidebar} from "../../../components/AccountSidebar.jsx";
import {ContentLocked} from "../../../components/ContentLocked.jsx";
import messages from "../../../messages/messages.js";
import API_URL from "../../../includes/api.js";
import {useAuth} from '../../../components/AuthProvider.jsx';
import {CircleSpinner} from "../../../components/Spinner.jsx";

function Artwork() {

    const {getToken, user, authLoading} = useAuth();

    const [pageLoading, setPageLoading] = useState(true);
    const [allowed, setAllowed] = useState(false);

    useEffect(() => {
        if (authLoading) return;

        if (!user) return;

        getToken().then((token) => {
            fetch(API_URL + "/website/get?firebase_auth_token=" + token)
                .then(response => response.json()).then(data => {
                if (data.code === 200) {
                    setAllowed(true);
                } else if (data.code === 201) {
                    setAllowed(true);
                }
            }).finally(() => {
                setPageLoading(false);
            });
        });
    }, [authLoading, user])

    return (
        <section className="text-white">

            <Helmet>
                <title>{messages["SITE.NAME"]} | My channel artwork</title>
                <meta name="description" content="My channel artwork"/>
            </Helmet>

            <div>

                <div className="flex flex-wrap">

                    <AccountSidebar/>

                    {pageLoading ? (
                        <div className="w-full md:w-3/4 px-0 md:px-4">
                            <div className="p-6 text-white rounded-lg bg-zinc-800">
                                <div className="flex items-center">
                                    <CircleSpinner/>
                                    <h3 className="text-lg m-0">Loading...</h3>
                                </div>
                            </div>
                        </div>
                    ) : (
                        !allowed ? (
                            <div className="w-full md:w-3/4 px-0 md:px-4">
                                <ContentLocked/>
                            </div>
                        ) : (
                            <div className="w-full md:w-3/4 px-0 md:px-4">
                                <div className="border border-border/60 bg-zinc-800 rounded-lg p-6 mb-3">
                                    <h2 className="text-2xl font-semibold mb-4">My channel artwork</h2>
                                    <p className="text-sm">
                                        If you're interested in requesting custom artwork, we're thrilled to help bring
                                        your ideas to life.<br/>
                                        To get started, please log a ticket on our Discord server
                                        with all the details of your request. You can find our Discord server
                                        at <a target="_blank" rel="noopener noreferrer"
                                              href={messages["DISCORD_URL"]}>{messages["DISCORD_URL"]}</a>.
                                    </p>
                                    <p className="text-sm mb-0">Don't worry if you're not on Discord – you can
                                        also reach us by visiting the <a
                                            href={"https://www." + messages["DOMAIN"] + "/get-in-touch?topic=other"}>Contact</a> page
                                        on our website. We can't wait to work with you and create something amazing
                                        together
                                    </p>
                                </div>
                            </div>
                        )
                    )}
                </div>
            </div>
        </section>
    );
}
